/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    title: {
        fontSize: '2.5rem',
        margin: `0px 0px ${theme.spacing(4)}px`,
        fontFamily: theme.typography.secondaryFontFamily,
        lineHeight: '32px',
        textAlign: 'center',
        fontWeight: 400,
    },
});

const ProductTitle = ({ title, classes }) => <h2 className={classes.title}>{title}</h2>;

ProductTitle.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
};

export default withStyles(styles)(ProductTitle);
